<template>
  <div class="article-container">
    <!-- 主内容包装 -->
    <div class="rich_media_wrp" id="img-content">
      <!-- 文章标题 -->
      <h1 class="rich_media_title" id="activity-name">
        {{ $t('newsinfo.proton.title') }}
      </h1>

      <!-- 正文内容 -->
      <div class="rich_media_content js_underline_content defaultNoSetting" id="js_content">
        <section class="main-section">
          <!-- 引言框 -->
          <section class="introduction-box">
            <div class="intro-content">
              <p class="intro-text">
                <strong>{{ $t('newsinfo.proton.introduction.intro1') }}</strong>
                <strong>{{ $t('newsinfo.proton.introduction.intro2') }}</strong>
              </p>
            </div>
          </section>

          <!-- 主图 -->
          <section class="main-image">
            <img 
              src="https://www.healthcode.com/media/news/shanghaitechnews_files/640(1).jpg" 
              :alt="$t('newsinfo.proton.altPlatform')"
            >
          </section>

          <!-- 政策背景段落 -->
          <p class="content-paragraph">
            {{ $t('newsinfo.proton.policy') }}
          </p>

          <!-- 小图1 -->
          <section class="small-image">
            <img 
              src="https://www.healthcode.com/media/news/shanghaitechnews_files/640(2).jpg" 
              :alt="$t('newsinfo.proton.altAccelerate')"
            >
          </section>

          <!-- 蓝色标题 -->
          <section class="blue-title-section">
            <p class="blue-title"><strong>{{ $t('newsinfo.proton.aiDesign.title1') }}</strong></p>
            <p class="blue-title"><strong>{{ $t('newsinfo.proton.aiDesign.title2') }}</strong></p>
          </section>

          <!-- 内容段落 -->
          <p class="content-paragraph">
            {{ $t('newsinfo.proton.aiDesign.paragraph1') }}
          </p>

          <p class="content-paragraph">
            {{ $t('newsinfo.proton.aiDesign.question') }}
          </p>

          <!-- 图片2 -->
          <section class="full-image">
            <img 
              src="https://www.healthcode.com/media/news/shanghaitechnews_files/640(3).jpg" 
              :alt="$t('newsinfo.proton.altProteinDesign')"
            >
          </section>

          <!-- 技术介绍段落 -->
          <div class="technology-section">
            <p class="content-paragraph">
              {{ $t('newsinfo.proton.technology.answer') }}
            </p>

            <p class="content-paragraph">
              {{ $t('newsinfo.proton.technology.paragraph1') }}
            </p>

            <p class="content-paragraph">
              {{ $t('newsinfo.proton.technology.paragraph2') }}
            </p>

            <p class="content-paragraph">
              {{ $t('newsinfo.proton.technology.paragraph3') }}
            </p>

            <p class="content-paragraph">
              {{ $t('newsinfo.proton.technology.paragraph4') }}
            </p>

            <p class="content-paragraph">
              {{ $t('newsinfo.proton.technology.paragraph5') }}
            </p>
          </div>

          <!-- 图片3 -->
          <section class="full-image">
            <img 
              src="https://www.healthcode.com/media/news/shanghaitechnews_files/640(4).jpg" 
              :alt="$t('newsinfo.proton.altCooperation')"
            >
          </section>

          <!-- 产业化段落 -->
          <div class="industrialization-section">
            <p class="content-paragraph">
              {{ $t('newsinfo.proton.industrialization.paragraph1') }}
            </p>

            <p class="content-paragraph">
              {{ $t('newsinfo.proton.industrialization.paragraph2') }}
            </p>
          </div>

          <!-- 小图2 -->
          <section class="small-image">
            <img 
              src="https://www.healthcode.com/media/news/shanghaitechnews_files/640(5).jpg" 
              :alt="$t('newsinfo.proton.altReorganization')"
            >
          </section>

          <!-- 第二个蓝色标题 -->
          <section class="blue-title-section">
            <p class="blue-title"><strong>{{ $t('newsinfo.proton.collaboration.title1') }}</strong></p>
            <p class="blue-title"><strong>{{ $t('newsinfo.proton.collaboration.title2') }}</strong></p>
          </section>

          <!-- 协作模式段落 -->
          <div class="collaboration-section">
            <p class="content-paragraph">
              {{ $t('newsinfo.proton.collaboration.paragraph1') }}
            </p>

            <p class="content-paragraph">
              {{ $t('newsinfo.proton.collaboration.paragraph2') }}
            </p>

            <p class="content-paragraph">
              {{ $t('newsinfo.proton.collaboration.paragraph3') }}
            </p>
          </div>

          <!-- 图片4 -->
          <section class="full-image">
            <img 
              src="https://www.healthcode.com/media/news/shanghaitechnews_files/640(6).jpg" 
              :alt="$t('newsinfo.proton.altPlatformConstruction')"
            >
          </section>

          <!-- 平台建设段落 -->
          <div class="platform-section">
            <p class="content-paragraph">
              {{ $t('newsinfo.proton.platform.paragraph1') }}
            </p>

            <p class="content-paragraph">
              {{ $t('newsinfo.proton.platform.paragraph2') }}
            </p>

            <p class="content-paragraph">
              {{ $t('newsinfo.proton.platform.quote') }}
            </p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale, t } = useI18n();

const currentLang = computed(() => locale.value);

const switchLanguage = (lang) => {
  locale.value = lang;
  localStorage.setItem('locale', lang);
};

// 监听语言变化并执行相应操作
watch(locale, (newLocale) => {
  console.log(`语言已切换到: ${newLocale}`);
});

console.log('AI蛋白质智造新闻页面加载完成');
</script>

<style scoped>
/* 语言切换按钮样式 */
.language-switcher {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
  display: flex;
  gap: 5px;
}

.language-switcher button {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.language-switcher button:hover {
  background-color: #e0e0e0;
}

.language-switcher button.active {
  background-color: #2e3b7a;
  color: white;
  border-color: #2e3b7a;
}

/* 基础容器样式 */
.article-container {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  color: #3e3e3e;
  line-height: 1.6;
  background-color: #fff;
}

.rich_media_wrp {
  padding: 0 10px;
  box-sizing: border-box;
}

/* 文章标题样式 */
.rich_media_title {
  font-size: 22px;
  font-weight: bold;
  margin: 20px 0 15px;
  color: #1a1a1a;
  line-height: 1.4;
  text-align: left;
  margin-top: 100px;
}

/* 隐藏的小说卡片 */
.novel-card {
  display: none;
}

/* 引言框样式 */
.introduction-box {
  margin: 10px 0;
  display: inline-block;
  width: 100%;
  border: 1px solid #a7c4e4;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(170, 170, 170, 0.3);
  border-radius: 4px;
}

.intro-content {
  margin: 10px 0;
  width: 100%;
}

.intro-text {
  margin: 0;
  padding: 0;
  color: #0f569b;
  font-size: 16px;
  line-height: 1.8;
}

.intro-text strong {
  display: block;
  margin-bottom: 5px;
}

/* 图片通用样式 */
.main-image,
.full-image {
  text-align: left;
  margin: 10px 0;
  line-height: 0;
}

.main-image img,
.full-image img {
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
}

/* 小图样式 */
.small-image {
  text-align: left;
  margin: 10px 0;
  line-height: 0;
}

.small-image img {
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  width: 45%;
  height: auto;
}

/* 内容段落样式 */
.content-paragraph {
  margin: 0 0 15px;
  padding: 0;
  font-size: 16px;
  line-height: 1.8;
  text-align: justify;
  white-space: normal;
}

.content-paragraph:last-child {
  margin-bottom: 0;
}

/* 蓝色标题部分 */
.blue-title-section {
  margin: 15px 0;
}

.blue-title {
  margin: 0 0 5px;
  padding: 0;
  color: #226ca8;
  font-size: 16px;
  line-height: 1.5;
}

.blue-title:last-child {
  margin-bottom: 0;
}

/* 技术介绍部分 */
.technology-section,
.industrialization-section,
.collaboration-section,
.platform-section {
  margin: 20px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .rich_media_wrp {
    padding: 0 8px;
  }
  
  .rich_media_title {
    font-size: 20px;
    margin: 15px 0 12px;
  }
  
  .intro-text,
  .content-paragraph {
    font-size: 15px;
  }
  
  .blue-title {
    font-size: 15px;
  }
  
  .small-image img {
    width: 50%;
  }
  
  .language-switcher {
    position: static;
    justify-content: center;
    margin-bottom: 10px;
  }
}

@media (max-width: 480px) {
  .rich_media_wrp {
    padding: 0 5px;
  }
  
  .rich_media_title {
    font-size: 18px;
    margin: 12px 0 10px;
  }
  
  .intro-text,
  .content-paragraph {
    font-size: 14px;
    line-height: 1.7;
  }
  
  .blue-title {
    font-size: 14px;
  }
  
  .small-image img {
    width: 60%;
  }
  
  .introduction-box {
    padding: 8px;
  }
}

/* 暗色模式支持 */
@media (prefers-color-scheme: dark) {
  .article-container {
    color: #e0e0e0;
    background-color: #1a1a1a;
  }
  
  .rich_media_title {
    color: #ffffff;
  }
  
  .introduction-box {
    background-color: #2a2a2a;
    border-color: #4a6a8c;
  }
  
  .intro-text {
    color: #6ca8ff;
  }
  
  .blue-title {
    color: #6ca8ff;
  }
}

/* 打印样式 */
@media print {
  .article-container {
    max-width: 100%;
    padding: 0;
  }
  
  .rich_media_title {
    font-size: 20px;
    margin: 15mm 0 10mm;
  }
  
  .introduction-box {
    border: 1px solid #000;
    box-shadow: none;
    margin: 5mm 0;
  }
  
  .main-image img,
  .full-image img,
  .small-image img {
    max-height: 150mm;
    object-fit: contain;
  }
  
  .content-paragraph {
    margin: 0 0 3mm;
    font-size: 12pt;
    line-height: 1.5;
  }
}
</style>